import { render, staticRenderFns } from "./ShippingReturns.vue?vue&type=template&id=a1059da8&scoped=true&"
import script from "./ShippingReturns.vue?vue&type=script&lang=js&"
export * from "./ShippingReturns.vue?vue&type=script&lang=js&"
import style0 from "./ShippingReturns.vue?vue&type=style&index=0&id=a1059da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1059da8",
  null
  
)

export default component.exports